export enum ToggleButtonSizeType {
  DEFAULT = 'default',
  SMALL = 'small',
  LARGE = 'large',
}

export type ToggleButtonSizeProperties = {
  width: string;
  height: string;
  thumbSize: string;
  /**
   * Where the thumb should be positioned in the X-drection
   * within the toggle when switched off.
   */
  uncheckedPosition: string;
  /**
   * Where the thumb should be positioned in the X-direction
   * within the toggle when switched on.
   */
  checkedPosition: string;
};

export type ToggleButtonSizeStyles = Record<
  ToggleButtonSizeType,
  ToggleButtonSizeProperties
>;

export interface ToggleButtonProps {
  id?: string;
  className?: string;
  disabled?: boolean;
  checked?: boolean;
  handleToggleClick?: (checked: boolean) => void;
  margin?: string;
  /**
   * Color value (hex/rgb) of the background when the toggle when checked.
   */
  checkedColor?: string;
  /**
   * Color value (hex/rgb) of the background when the toggle is not checked.
   */
  uncheckedColor?: string;
  /**
   * The size of the toggle.
   *
   * Ensure to import `ToggleButtonSizeType` and use as ex: ToggleButtonSizeType.SMALL
   */
  size?: ToggleButtonSizeType;
  ariaLabelledBy?: string;
  /**
   * Used for third-party tracking services.
   */
  dataId?: string;
  /**
   * This allows the element to be accessible by the given title.
   * This can be especially useful for targeting the element accurately in a test.
   */
  title?: string;
}

export interface StyledSwitchProps {
  $width: string;
  $height: string;
  $margin?: string;
  $checkedColor: string;
  $uncheckedColor: string;
}

export interface StyledThumbProps {
  $size: string;
  $uncheckedPosition: string;
  $checkedPosition: string;
}
